import script from "./PasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordForm.vue?vue&type=style&index=0&id=7b04087a&lang=css"

const __exports__ = script;

export default __exports__